// @flow
import React, { Component } from 'react';

import NavItem from './NavItem';
import type { PageData } from './pageData';
import PageRoute from './PageRoute';

import '../admin-styles.css';

type Props = {
  className?: string,
  hasIdentityService: boolean,
  isFullAdmin: boolean,
  isLicensed?: boolean,
  navItemClass: string,
  navListClass?: string,
  pages: Array<PageData>,
};

export default class Nav extends Component<Props> {
  render() {
    const {
      className,
      isFullAdmin,
      isLicensed,
      hasIdentityService,
      navItemClass,
      navListClass,
      pages,
    } = this.props;
    return (
      <div className={className || 'nav'}>
        <div className={navListClass}>
          {pages &&
            pages.map(
              page =>
                (isFullAdmin || page.visibleForCatalogAdmin) && (
                  <NavItem
                    hasIdentityService={hasIdentityService}
                    isFullAdmin={isFullAdmin}
                    isLicensed={isLicensed || false}
                    key={page.label.defaultMessage}
                    navItemClass={navItemClass}
                    page={page}
                  />
                )
            )}
        </div>

        <div className="page-container" id="pageContainer">
          {pages &&
            pages.map(
              page =>
                (isFullAdmin || page.visibleForCatalogAdmin) && (
                  <PageRoute
                    hasIdentityService={hasIdentityService}
                    isFullAdmin={isFullAdmin}
                    key={page.route + '-page'}
                    page={page}
                  />
                )
            )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/App/Nav.js